import { ActorModel, SupportedActorType } from "../fhir/fhir.types";

export interface TimeInterval {
  start: string;
  end: string;
}

export interface PlanningSlot extends TimeInterval {
  id: string;
  scheduleId: string;
  scheduleLabel: string;
  status: string;
  overbooked: boolean;
}

export interface PlanningAppointment extends TimeInterval {
  id: string;
  title: string;
  status: string;
}

export type PlanningConflictKind = "slot" | "appointment";

export interface PlanningConflict extends TimeInterval {
  kind: PlanningConflictKind;
  id: string;
  label: string;
  status: string;
}

export interface ActorAvailability {
  actor: ActorModel;
  slots: PlanningSlot[];
  appointments: PlanningAppointment[];
}

export interface PlanningSuggestion extends TimeInterval {
  compatibleSlotIdsByActor: Record<string, string[]>;
  conflictsByActor: Record<string, PlanningConflict[]>;
}

export interface PlanningComparison {
  range: TimeInterval;
  durationMinutes: number;
  actors: ActorAvailability[];
  knownClear: TimeInterval[];
  suggestions: PlanningSuggestion[];
}

export interface AppointmentDraft {
  title: string;
  actors: ActorModel[];
  durationMinutes: number;
  range: TimeInterval;
  selected?: PlanningSuggestion;
  selectedSlotIdByActor: Record<string, string | undefined>;
  comment?: string;
}

export type ActorPickerKind = "participant" | "location" | "device";

export const pickerActorTypes: Record<ActorPickerKind, SupportedActorType[]> = {
  participant: ["patient", "practitioner"],
  location: ["location"],
  device: ["device"],
};
